
function getType(fileName){
	let parts = fileName.split('.');
	return parts[parts.length - 1];
}

const generateValidator = (fields) => {
	return (values) => {
		let errors = {}
		for (let field of fields){
			if(field.value && field.value.constructor === Array){
				if(values[field.name]){
					errors[field.name] = generateValidator(field.value)(values[field.name]);
				}
			}
			if(field.required){
				if(!values[field.name] || (!field.range && (values[field.name] === 'false'))){
					errors[field.name] = 'Este campo es obligatorio';
				}
			}
			if(field.range){
				if(('min' in field.range && values[field.name] < field.range.min) || ('max' in field.range && values[field.name] > field.range.max)){
					errors[field.name] = 'Valor no permitido';
				}
			}
			if(field.accepted_types && values[field.name]){
				const fileType = getType(values[field.name][0].name);
				if(!field.accepted_types.includes(fileType)){
					errors[field.name] = 'El tipo de archivo no es compatible';
				}
			}
		}
		return errors
	};
}

export default generateValidator


/** WEBPACK FOOTER **
 ** ./src/components/Validations/generateValidator.js
 **/